import { COMPONENT_NAME as ITEM_SWAPPER_COMPONENT_NAME, ItemSwapperComponent } from './item-swapper/item-swapper.component'
import { DIRECTIVE_NAME as ITEM_SWAPPER_POPUP_DIRECTIVE_NAME, ItemSwapperPopupDirective } from './item-swapper-popup/item-swapper-popup.directive'

export const ITEM_SWAPPER_MODULE_NAME = 'simax.common.item-swapper'

const module = angular.module(ITEM_SWAPPER_MODULE_NAME, [])

module.component(ITEM_SWAPPER_COMPONENT_NAME, new ItemSwapperComponent())

module.directive(ITEM_SWAPPER_POPUP_DIRECTIVE_NAME, [() => new ItemSwapperPopupDirective()])
